import React from 'react';
import { useSelector } from 'react-redux';
import { Carousel, CollapseWrapper, ProductTile, ProductTileSkeleton } from '@hpi-sox/hpstellar-core';
import { Helpers } from '../../../core/src/helpers';

import withPageComponents from '../../../page/components/with-page-components';
import useAddToCart from '../../../hooks/useAddToCart';
import useProductPrice from '../../../hooks/useProductPrice';
import useProductCompare from '../../../hooks/useProductCompare';
import { ColorSelectorContainer } from '../../../hooks/useColorSelector';
import useCartState from '../../../hooks/useCartState';
import useProductImpressions from '../../../hooks/useProductImpressionsV2';
import getProductProps from '../../../product/get-product-props';
import { getAvailableProducts } from '../../../hooks/useProductProps';

import './upsell.less';
const getSlickSettings = isBot => {
    const settings = {
        dots: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        className: 'upsellCarousel',
        nextArrowClassName: 'upsellArrowNext',
        prevArrowClassName: 'upsellArrowPrev',
        lazyLoad: isBot ? null : 'progressive',
        equalHeight: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1560,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true,
                    arrows: true,
                    infinite: false,
                },
            },
            {
                breakpoint: 1175,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: true,
                    infinite: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    infinite: false,
                },
            },
        ],
    };
    return settings;
};

const pdpUpSell = ({
    pdpSimilarProducts,
    pdpSimilarProductsLink,
    productInitial,
    hideOOS = true,
    id,
    vanityUrl,
    isBot,
}) => {
    const { products: productsList, sectionTitle } = pdpSimilarProducts || {};
    const baseProductSku = productInitial && productInitial.sku;
    const { pageViewWithDelayedMetrics } = useSelector(state => (state && state.metrics) || {});
    const { prices } = useProductPrice(productsList);
    const addToCart = useAddToCart(true);
    const compare = useProductCompare();
    const { cartId } = useCartState();
    const inStockProducts = hideOOS ? getAvailableProducts(productsList, prices) : [];
    let upSellProducts = inStockProducts.length > 0 ? inStockProducts : productsList;
    let waitingForPrice =
        !productsList ||
        productsList.length === 0 ||
        productsList.some(prd => {
            let { sku } = prd || {};
            let price = prices && prices[sku];
            return !price || (!price.regularPrice && !price.salePrice && !price.priceFetchError);
        });
    let metricsUnavailable =
        waitingForPrice ||
        !vanityUrl ||
        !pageViewWithDelayedMetrics ||
        pageViewWithDelayedMetrics !== vanityUrl ||
        (metricProducts && metricProducts.length === 0);

    const list = 'pdp';
    // const metricProducts = hideOOS ? inStockProducts : upSellProducts;
    const upsellProductsWithAnalytics = useProductImpressions({
        // products: metricsUnavailable ? [] : metricProducts,
        products: upSellProducts,
        list,
        componentKey: 'pdpSimilarProducts',
        key: baseProductSku,
        // isEmpty: metricsUnavailable, // trigger only when this evaluates to false
        // customPrices: getPriceMetricInput(metricProducts, prices),
        // trackMetrics: true, // separate and after page view
    });

    const hasProducts = upsellProductsWithAnalytics && upsellProductsWithAnalytics.length > 0;
    const shouldRender = hasProducts || pdpSimilarProductsLink;

    if (shouldRender) {
        return (
            <section id={id} className="pdp-upsell" tabIndex={0}>
                <CollapseWrapper
                    title={sectionTitle}
                    desktopTitle={sectionTitle}
                    desktopTitleTag="h2"
                    accordionProps={{ isStatic: true, size: 'small' }}
                    className="pdp-collapse-wrapper"
                    accordionTitleProps={{
                        className: 'collapse-wrapper-accordion',
                        TypographyProps: { variant: 'orionSubtitleLarge' },
                    }}
                    desktopTitleProps={{ variant: 'orionSubtitleLarge' }}
                >
                    <Carousel {...getSlickSettings(isBot)}>
                        {hasProducts
                            ? upsellProductsWithAnalytics.map((product, idx) => {
                                  return (
                                      <ColorSelectorContainer key={`${product.sku}${idx}`} product={product}>
                                          {({ colorSelection }) => (
                                              <ProductTile
                                                  {...getProductProps(
                                                      product,
                                                      prices[product.sku],
                                                      { addToCart, compare, colorSelection },
                                                      {
                                                          resizeImage: true,
                                                          hasPriceSeoText: true,
                                                      },
                                                      {
                                                          list,
                                                          ctoGtmId: 'cross-sell',
                                                          cartId,
                                                          position: idx + 1,
                                                          xsellProdInfo: baseProductSku,
                                                          xsellMethod: 'pdp-similarproducts',
                                                      },
                                                  )}
                                                  className="upsellTile"
                                                  fullHeight
                                                  ratingSpaceReserved={true}
                                              />
                                          )}
                                      </ColorSelectorContainer>
                                  );
                              })
                            : // Show skeleton tiles while products are loading
                              Array.from({ length: 4 }).map((_, idx) => (
                                  <ProductTileSkeleton key={`skeleton-${idx}`} className="upsellTile" />
                              ))}
                    </Carousel>
                </CollapseWrapper>
            </section>
        );
    }
    return null;
};

const PDPUpsell = withPageComponents(pdpUpSell, {
    components: ['pdpSimilarProducts', 'productInitial', 'pdpSimilarProductsLink'],
});

export default PDPUpsell;
